import { Container } from "./FooterStyles";
import SocialMedia from "./SocialMedia";
import Logo from "./Logo";

export default function Footer() {
  return (
    <Container>
      <SocialMedia />
      <Logo />
    </Container>
  );
}
